export default "https://housescan.app.solease.nl/static/media/solar_panels.42ccaae6.svg";